import { render } from "./fieldCustomChecklist.vue?vue&type=template&id=24206bbf"
import script from "./fieldCustomChecklist.vue?vue&type=script&lang=js"
export * from "./fieldCustomChecklist.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__